export default __webpack_public_path__ + "images/0f46514660d6580dbb7f7e16cb95f272.svg";